import FileDownloadIcon from '@mui/icons-material/FileDownload';
import EditIcon from '@mui/icons-material/EditRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import { useSelector } from 'react-redux';
import { Typography } from '@components/Typography';
import ActionIconButton from '@components/ActionIconButton';
import { Card, CardFooter, CardControls, CardIconButton, CardDivider } from '@components/CardItem/styles';
import CardOwnerLabel from '@components/CardItem/OwnerLabel';
import { OWNER_TYPE } from '@components/OwnerIcon';
import { useLocations, useTranslation } from '@hooks';

const Metric = ({ label, value }) => (
    <Typography variant="caption" sx={{ color: 'var(--text-secondary)' }}>
        {label} <span style={{ color: 'var(--text-primary)' }}>{value ?? 0}</span>
    </Typography>
);

const FormItem = ({ form, canWrite, isSubmitting, onClickEdit, onClickDownload, onClickView, onClickDelete }) => {
    const { t } = useTranslation();
    const { locationsMap } = useLocations();
    const brands = useSelector(state => state.brands.data);

    const ownerName = form.brandId
        ? brands?.find(b => b.id === form.brandId)?.title
        : locationsMap[form.locationId]?.internalName;

    return (
        <Card sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2">{form.internalName}</Typography>
            <CardOwnerLabel type={form.brandId ? OWNER_TYPE.BRAND : OWNER_TYPE.LOCATION} name={ownerName} />
            <div style={{ marginTop: 'auto' }} />
            <CardDivider />
            <CardFooter>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Metric label={t('FormsPage.views')} value={form.viewsCount} />
                    <Metric label={t('FormsPage.submissions')} value={form.submissionsCount} />
                </div>
                <CardControls columns={canWrite ? 3 : 1}>
                    {canWrite ? (
                        <>
                            <ActionIconButton
                                title={t('common.edit')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={onClickEdit}
                            >
                                <EditIcon />
                            </ActionIconButton>
                            <ActionIconButton
                                title={t('FormsPage.downloadSubmissions')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={onClickDownload}
                            >
                                <FileDownloadIcon />
                            </ActionIconButton>
                            <ActionIconButton
                                title={t('common.delete')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={onClickDelete}
                            >
                                <DeleteIcon />
                            </ActionIconButton>
                        </>
                    ) : (
                        <ActionIconButton title={t('common.view')} component={CardIconButton} onClick={onClickView}>
                            <VisibilityIcon />
                        </ActionIconButton>
                    )}
                </CardControls>
            </CardFooter>
        </Card>
    );
};

export default FormItem;
